import { estimateTimeline, formatRange, type Script } from '@reelmachine/core';
import type { ScriptEditor } from './useScriptEditor';
import { lineName } from './ScriptTab';

const PERSON = /groß im Bild|Nahaufnahme|vor einem|close-up|on camera|talking head/i;

interface Props {
  script: Script;
  editor: ScriptEditor;
  brand: string;
  highlight: ReadonlySet<string>;
  readOnly: boolean;
}

/** 9:16 frames in the channel's brand colour with the on-screen text; the visual is editable per frame. */
export function StoryboardTab({ script, editor, brand, highlight, readOnly }: Props) {
  const timeline = estimateTimeline({ lines: script.lines.map((l) => ({ ...l, text: editor.value(l.id, 'text') })) });
  return (
    <div className="frames">
      {script.lines.map((line, i) => {
        const visual = editor.value(line.id, 'visual');
        return (
          <div className={`frame ${highlight.has(`line:${line.id}`) ? 'changed' : ''}`.trim()} key={line.id}>
            <div className="vf" role="img" aria-label={`${lineName(i)} frame: ${editor.value(line.id, 'onScreen')}`}>
              <div className="band" style={{ background: `linear-gradient(${brand}, transparent)` }} />
              {PERSON.test(visual) && <div className="person" />}
              <span className="tc">{timeline[i] && formatRange(timeline[i])}</span>
              <div className="ost">{editor.value(line.id, 'onScreen')}</div>
            </div>
            <label className="field-l" htmlFor={`visual-${line.id}`}>
              Visual
            </label>
            <textarea
              id={`visual-${line.id}`}
              rows={3}
              maxLength={400}
              readOnly={readOnly}
              className={highlight.has(`visual:${line.id}`) ? 'changed' : undefined}
              value={visual}
              onChange={(e) => editor.set(line.id, 'visual', e.target.value)}
            />
          </div>
        );
      })}
    </div>
  );
}
